import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { api } from '~/redux/api/createApi';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

export default function DocumentRedirect() {
  const intl = useIntl();
  const { navigate, getSearchParam } = useRouting();
  const contractRecordUniqueId = getSearchParam(
    'contract_record_unique_id',
    '',
  );
  const wssContractId = getSearchParam('wss_contract_id', '');
  const asOfDate = getSearchParam('as_of_date', undefined);
  const hasIdentifier = Boolean(contractRecordUniqueId || wssContractId);
  const {
    data: resolvedDocument,
    isLoading,
    isError,
  } = api.endpoints.resolveWssDocument.useQuery(
    {
      contractRecordUniqueId: contractRecordUniqueId || undefined,
      wssContractId: wssContractId || undefined,
      asOfDate,
      trackOriginal: false,
    },
    { skip: !hasIdentifier },
  );

  useEffect(() => {
    if (resolvedDocument) {
      navigate(
        RoutePathType.Document.replace(
          ':documentId',
          resolvedDocument.documentId.toString(),
        ),
        { replace: true },
      );
    }
  }, [resolvedDocument]);

  const placeholderContent =
    isError || !hasIdentifier
      ? {
          image: 'error-page-not-found',
          title: intl.formatMessage({
            id: 'DocumentRedirect.documentNotFoundTitle',
            defaultMessage: 'Document Not Found',
            description: 'Title for document not found error page',
          }),
          description: intl.formatMessage({
            id: 'DocumentRedirect.documentNotFoundDescription',
            defaultMessage:
              'The associated document could not be found. It may have been deleted or does not exist.',
            description: 'Description for document not found error message',
          }),
        }
      : undefined;

  return (
    <ContentContainer
      placeholderContent={placeholderContent}
      loadingContent={{ isLoading }}
    >
      <></>
    </ContentContainer>
  );
}
